import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventCopyPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Duplicate Event</EventSubPageTitle>;
};
